export default __webpack_public_path__ + "static/media/AudiLogo_White.9252d858.svg";